import {EnvironnementDTO} from './environnement-dto';
import {ObjectDTO} from "./object-dto";

export class EnvironnementSitesVisiblesDTO extends ObjectDTO {
  id: number;
  ordre: number;
  environnementDTO: EnvironnementDTO;
  local: boolean;
}
